export default {
    AudioStore: {
        getdata: []
    }
};